import React from 'react';
import { Book, Language } from '../types';

interface BookCardProps {
  book: Book;
  rank: number;
  language: Language;
}

const BookCard: React.FC<BookCardProps> = ({ book, rank, language }) => {
  // Generate a random gradient based on rank for visual variety
  const gradients = [
    'from-blue-400 to-indigo-600',
    'from-emerald-400 to-teal-600',
    'from-orange-400 to-red-600',
    'from-purple-400 to-pink-600',
    'from-cyan-400 to-blue-600',
  ];
  const bgClass = gradients[rank % gradients.length];

  return (
    <div className="bg-white dark:bg-slate-800 rounded-xl shadow-lg overflow-hidden transform transition hover:-translate-y-1 hover:shadow-xl border border-gray-100 dark:border-slate-700 flex flex-col h-full">
      <div className={`h-32 bg-gradient-to-r ${bgClass} p-4 flex items-end justify-between relative`}>
        <span className="absolute top-0 right-0 bg-white/20 text-white text-4xl font-bold p-4 leading-none opacity-50">
          #{rank}
        </span>
        <div className={`text-white drop-shadow-md w-full ${language === 'fa' ? 'text-right' : 'text-left'}`}>
           <p className="text-xs opacity-90 mb-1">{book.publishedYear}</p>
           <h3 className="font-bold text-lg leading-tight line-clamp-2">{book.title}</h3>
        </div>
      </div>
      
      <div className="p-5 flex-grow flex flex-col">
        <div className={`flex justify-between items-center mb-3 ${language === 'en' ? 'flex-row-reverse' : ''}`}>
          <div className="flex items-center bg-yellow-50 dark:bg-yellow-900/30 px-2 py-1 rounded-lg border border-yellow-100 dark:border-yellow-900/50">
             <span className="text-yellow-500 text-lg mx-1">★</span>
             <span className="font-bold text-gray-700 dark:text-gray-200">{book.rating}</span>
          </div>
          <p className="text-sm text-gray-500 dark:text-gray-400 font-medium">{book.author}</p>
        </div>
        
        <p className={`text-gray-600 dark:text-gray-300 text-sm leading-7 text-justify mb-4 flex-grow ${language === 'en' ? 'text-left' : 'text-right'}`}>
          {book.description}
        </p>
      </div>
    </div>
  );
};

export default BookCard;